import { ColDef } from "ag-grid-community";
import { dateFormatter } from "../config/Global";
import { generateColumn, renderNA, setDateFilterDefs } from "./commonFunctions";
import dateComparator from "./dateComparator";
import SwitchCellRenderer from "./cellRenderer/SwitchCellRenderer";
export const idColumn: ColDef = {
  field: "id",
  headerName: "ID",
  pinned: "left",
  width: 120,
  minWidth: 120,
};

export const nameColumn: ColDef = {
  field: "name",
  headerName: "Name",
  cellRenderer: (props: any) => {
    return renderNA(props.data.name);
  },
};
export const codeColumn: ColDef = {
  field: "code",
  headerName: "Code",
  cellRenderer: (props: any) => {
    return renderNA(props.data.code);
  },
  filterValueGetter: (props: any) => {
    return renderNA(props.data.code);
  },
};

export const firstNameColumn: ColDef = {
  field: "name",
  headerName: "First Name",
  cellRenderer: (props: any) => {
    return renderNA(props.data.name);
  },
  filterValueGetter: (props: any) => {
    return renderNA(props.data.name);
  },
};
export const lastNameColumn: ColDef = {
  field: "last_name",
  headerName: "Last Name",
  cellRenderer: (props: any) => {
    return renderNA(props.data.last_name);
  },
  filterValueGetter: (props: any) => {
    return renderNA(props.data.last_name);
  },
};

export const statusColumn: ColDef = {
  field: "display_status",
  headerName: "Status",
  sortable: false,
  width: 150,
  minWidth: 150,
  cellRenderer: SwitchCellRenderer,
  filter: "agSetColumnFilter",
  filterParams: {
    values: (params: any) => {
      params.success(["Active", "Inactive"]);
    },
    buttons: ["apply", "reset"],
    closeOnApply: true,
  },
};

export const isActiveColumn: ColDef = {
  field: "is_active",
  headerName: "Is Active?",
  filter: "agSetColumnFilter",
  cellRenderer: (props: any) => {
    return renderNA(props.data.name);
  },
  filterParams: {
    values: (params: any) => {
      const data = ["Active", "Deactivate"];
      params.success(data);
    },
    buttons: ["apply", "reset"],
    closeOnApply: true,
  },
};

export const actionColumn: ColDef = {
  field: "",
  headerName: "Action",
  type: "actionColumn",
  sortable: false,
  filter: false,
  width: 100,
  minWidth: 100,
  pinned: "right",
  suppressMenu: true,
};

export const startTimeColumn: ColDef = {
  ...generateColumn("Start Time"),
  width: 200,
  minWidth: 200,
  cellRenderer: (props: any) => {
    return props.data.start_time
      ? dateFormatter(props.data.start_time, "DD-MM-YYYY hh:mm:ss A")
      : "N/A";
  },
  ...setDateFilterDefs(),
};

export const endTimeColumn: ColDef = {
  ...generateColumn("End Time"),
  width: 200,
  minWidth: 200,
  cellRenderer: (props: any) => {
    return props.data.end_time
      ? dateFormatter(props.data.end_time, "DD-MM-YYYY hh:mm:ss A")
      : "N/A";
  },
  ...setDateFilterDefs(),
};

export const createdAtColumn: ColDef = {
  field: "created_at",
  headerName: "Created at",
  sortable: true,
  width: 200,
  minWidth: 200,
  filter: "agDateColumnFilter",
  cellRenderer: (props: any) => {
    return props.data.created_at ? dateFormatter(props.data.created_at) : "N/A";
  },
  filterParams: {
    buttons: ["apply", "reset"],
    inRangeInclusive: true,
    suppressAndOrCondition: true,
    comparator: dateComparator,
    browserDatePicker: true,
  },
};
export const updatedAtColumn: ColDef = {
  field: "updated_at",
  headerName: "Updated at",
  sortable: true,
  width: 200,
  minWidth: 200,
  filter: "agDateColumnFilter",
  cellRenderer: (props: any) => {
    return props.data.updated_at ? dateFormatter(props.data.updated_at) : "N/A";
  },
  filterParams: {
    buttons: ["apply", "reset"],
    inRangeInclusive: true,
    suppressAndOrCondition: true,
    comparator: dateComparator,
    browserDatePicker: true,
  },
};

export const questionColumn: ColDef = generateColumn("Question");
